var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { fetchAppMetadata } from '../../../utils/appMetadata';
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import constants, { FUNDING_LOG_COUNTRY_OPTIONS } from '../../../config/constants';
import { utility } from '../../../utils';
import { deriveCustomerType } from '../components/CustomerTypeIcon';
import { getNewCounts, getNewRowIds, getNextExpiry, loadFundingLogNewTracking, pruneFundingLogNewTracking, saveFundingLogNewTracking, } from './fundingLogNewTracker';
export var FUNDING_LOG_ACCOUNT_NOT_IN_ASPIRE_MESSAGE = 'This account is not present in Aspire.';
export var deriveFundingLogRoleTier = function (roleDescription) { return ((roleDescription || '').trim().toLowerCase() === 'cm - final review' ? 'L2' : 'L1'); };
export var isFundingLogReviewerRole = function (roleDescription) {
    var normalized = (roleDescription || '').trim().toLowerCase();
    return normalized === 'cm - initial review' || normalized === 'cm - final review';
};
export var FUNDING_LOG_CONTRACT_STATUS = {
    SALES_SUPPORT: '62 - Returned to Sales Support',
    FUNDED: '65 - Set to Fund',
    RETURNED_TO_CM: '63 - Return to CM',
};
export var isFundingLogRowLocked = function (status) {
    var normalized = (status || '').trim().toLowerCase();
    return normalized === 'booked' || normalized.includes('set to fund');
};
export var isFundingLogRowReturnedToCM = function (status) { return ((status || '').trim().toLowerCase().includes('return to cm')); };
export var EMPTY_FUNDING_LOG_FILTERS = {
    country: null,
    programs: [],
    status: [],
    fundingMethods: [],
    financeProgramGroups: [],
    salesRep: [],
    passedToBookingDateStart: '',
    passedToBookingDateEnd: '',
    expectedFundingDateStart: '',
    expectedFundingDateEnd: '',
    fundingDateStart: '',
    fundingDateEnd: '',
    bookedDateStart: '',
    bookedDateEnd: '',
};
var pickFirst = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
        var value = values_1[_a];
        if (value !== undefined && value !== null && "".concat(value).trim() !== '') {
            return value;
        }
    }
    return undefined;
};
var toIsoDateTime = function (dateOnly, endOfDay) {
    if (endOfDay === void 0) { endOfDay = false; }
    if (!dateOnly)
        return undefined;
    var parsed = new Date("".concat(dateOnly, "T").concat(endOfDay ? '23:59:59.999' : '00:00:00.000', "Z"));
    return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
};
var toDateRange = function (start, end) {
    var StartDate = toIsoDateTime(start);
    var EndDate = toIsoDateTime(end || start, true);
    return StartDate && EndDate ? { StartDate: StartDate, EndDate: EndDate } : undefined;
};
var FUNDING_LOG_API_DATE_FORMAT = 'MM/DD/YYYY h:mm:ss:SSSA';
export var FUNDING_LOG_DISPLAY_DATE_FORMAT = 'MM/DD/YYYY | hh:mm A';
export var FUNDING_LOG_DISPLAY_DATE_ONLY_FORMAT = 'MM/DD/YYYY';
export var formatFundingLogDate = function (value, displayFormat) {
    if (displayFormat === void 0) { displayFormat = FUNDING_LOG_DISPLAY_DATE_FORMAT; }
    if (!value)
        return '';
    var raw = String(value);
    var customParsed = moment(raw, FUNDING_LOG_API_DATE_FORMAT, true);
    if (customParsed.isValid())
        return customParsed.format(displayFormat);
    var isoParsed = moment(raw);
    return isoParsed.isValid() ? isoParsed.format(displayFormat) : raw;
};
var FUNDING_LOG_TIMEZONE = 'America/New_York';
var parseFundingLogDate = function (value) {
    if (!value)
        return undefined;
    var raw = String(value);
    var customParsed = moment.tz(raw, FUNDING_LOG_API_DATE_FORMAT, true, FUNDING_LOG_TIMEZONE);
    var parsed = customParsed.isValid() ? customParsed : moment.tz(raw, FUNDING_LOG_TIMEZONE);
    return parsed.isValid() ? parsed : undefined;
};
var parseFundingLogDatePlain = function (value) {
    if (!value)
        return undefined;
    var raw = String(value);
    var customParsed = moment(raw, FUNDING_LOG_API_DATE_FORMAT, true);
    var parsed = customParsed.isValid() ? customParsed : moment(raw);
    return parsed.isValid() ? parsed : undefined;
};
var deriveFundingLogElapsedLabel = function (from, to) {
    var totalMinutes = Math.max(0, to.diff(from, 'minutes'));
    var days = Math.floor(totalMinutes / (24 * 60));
    var hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    var minutes = totalMinutes % 60;
    if (days >= 1)
        return "".concat(days, "d ").concat(hours, "h");
    if (hours >= 1)
        return "".concat(hours, "h ").concat(minutes, "m");
    return "".concat(minutes, "m");
};
export var deriveFundingLogPassedToBookingAge = function (value) {
    var parsed = parseFundingLogDate(value);
    if (!parsed)
        return undefined;
    return deriveFundingLogElapsedLabel(parsed, moment());
};
export var deriveFundingLogBookingDuration = function (passedToBookingValue, bookedValue) {
    var passedToBooking = parseFundingLogDatePlain(passedToBookingValue);
    var booked = parseFundingLogDatePlain(bookedValue);
    if (!passedToBooking || !booked)
        return undefined;
    return deriveFundingLogElapsedLabel(passedToBooking, booked);
};
var SALES_SUPPORT_CONTRACT_STATUS = '62 - Returned to Sales Support';
var deriveAssigneeTier = function (item) {
    var status = pickFirst(item === null || item === void 0 ? void 0 : item.CurrentStatus, item === null || item === void 0 ? void 0 : item.ContractStatus);
    if (status === SALES_SUPPORT_CONTRACT_STATUS)
        return 'SALES_SUPPORT';
    var finalReviewCMName = item === null || item === void 0 ? void 0 : item.FinalReviewCMName;
    var hasFinalReviewCMName = finalReviewCMName !== undefined && finalReviewCMName !== null && "".concat(finalReviewCMName).trim() !== '';
    if (Number(item === null || item === void 0 ? void 0 : item.L2Assignment) === 1 || hasFinalReviewCMName)
        return 'L2';
    if (pickFirst(item === null || item === void 0 ? void 0 : item.InitialReviewCMName, item === null || item === void 0 ? void 0 : item.ContractManager) !== undefined)
        return 'L1';
    if (isFundingLogRowLocked(status) && pickFirst(item === null || item === void 0 ? void 0 : item.SalesSupportName) !== undefined)
        return 'SALES_SUPPORT';
    return undefined;
};
var deriveAssigneeName = function (item, tier) {
    var rawName = tier === 'L1'
        ? item === null || item === void 0 ? void 0 : item.InitialReviewCMName
        : tier === 'L2'
            ? item === null || item === void 0 ? void 0 : item.FinalReviewCMName
            : tier === 'SALES_SUPPORT'
                ? item === null || item === void 0 ? void 0 : item.SalesSupportName
                : undefined;
    return rawName !== undefined && rawName !== null && "".concat(rawName).trim() !== '' ? String(rawName) : undefined;
};
export var getFundingLogRowAssigneeId = function (row) {
    var _a, _b, _c, _d;
    var rawId = row.assigneeTier === 'L1'
        ? pickFirst((_a = row.raw) === null || _a === void 0 ? void 0 : _a.InitialReviewCMOId, (_b = row.raw) === null || _b === void 0 ? void 0 : _b.InitialReviewCMId)
        : row.assigneeTier === 'L2'
            ? pickFirst((_c = row.raw) === null || _c === void 0 ? void 0 : _c.FinalReviewCMOId, (_d = row.raw) === null || _d === void 0 ? void 0 : _d.FinalReviewCMId)
            : undefined;
    return rawId === null || rawId === undefined || rawId === '' ? undefined : rawId;
};
export var getFundingLogRowCurrentAssignees = function (row) {
    var _a, _b, _c, _d;
    var assignees = [];
    var initialReviewId = pickFirst((_a = row.raw) === null || _a === void 0 ? void 0 : _a.InitialReviewCMOId, (_b = row.raw) === null || _b === void 0 ? void 0 : _b.InitialReviewCMId);
    if (initialReviewId !== null && initialReviewId !== undefined && initialReviewId !== '') {
        assignees.push({ id: String(initialReviewId), label: 'Current Initial Reviewer' });
    }
    var finalReviewId = pickFirst((_c = row.raw) === null || _c === void 0 ? void 0 : _c.FinalReviewCMOId, (_d = row.raw) === null || _d === void 0 ? void 0 : _d.FinalReviewCMId);
    if (finalReviewId !== null && finalReviewId !== undefined && finalReviewId !== '') {
        assignees.push({ id: String(finalReviewId), label: 'Current Final Reviewer' });
    }
    return assignees;
};
export var getFundingLogRowHasFinalReviewCM = function (row) {
    var _a, _b;
    var finalReviewId = pickFirst((_a = row.raw) === null || _a === void 0 ? void 0 : _a.FinalReviewCMOId, (_b = row.raw) === null || _b === void 0 ? void 0 : _b.FinalReviewCMId);
    return finalReviewId !== null && finalReviewId !== undefined && finalReviewId !== '';
};
export var isFundingLogRowAssignedToSelf = function (row, accountAspireOId) {
    if (accountAspireOId === null || accountAspireOId === undefined || accountAspireOId === '')
        return false;
    var rowCMId = getFundingLogRowAssigneeId(row);
    if (rowCMId === undefined)
        return false;
    return String(rowCMId) === String(accountAspireOId);
};
var deriveDealTypeFromBookTreatment = function (bookTreatment) {
    var value = String(bookTreatment !== null && bookTreatment !== void 0 ? bookTreatment : '').toLowerCase();
    if (value.includes('lease'))
        return 'Lease';
    if (value.includes('loan'))
        return 'Loan';
    return '';
};
var mapFundingLogRow = function (item) {
    var _a, _b;
    var assigneeTier = deriveAssigneeTier(item);
    var status = String(pickFirst(item === null || item === void 0 ? void 0 : item.CurrentStatus, item === null || item === void 0 ? void 0 : item.ContractStatusOId, '--'));
    var customerType = deriveCustomerType(pickFirst(item === null || item === void 0 ? void 0 : item.FinanceProgramDescription, item === null || item === void 0 ? void 0 : item.FinanceProgram, item === null || item === void 0 ? void 0 : item.ProgramName, item === null || item === void 0 ? void 0 : item.Program));
    return {
        id: String(pickFirst(item === null || item === void 0 ? void 0 : item.ContractOId, item === null || item === void 0 ? void 0 : item.ContractId, '')),
        assigneeName: deriveAssigneeName(item, assigneeTier),
        assigneeTier: assigneeTier,
        contractId: String(pickFirst(item === null || item === void 0 ? void 0 : item.ContractId, '--')),
        customerName: String(pickFirst(item === null || item === void 0 ? void 0 : item.CustomerName, '--')),
        accountType: customerType,
        customerType: customerType,
        dealType: deriveDealTypeFromBookTreatment(item === null || item === void 0 ? void 0 : item.BookTreatment),
        status: status,
        passToBookingDate: formatFundingLogDate(item === null || item === void 0 ? void 0 : item.PasstoBookingDate),
        passToBookingAge: (item === null || item === void 0 ? void 0 : item.OriginalBookingDate) ? undefined : deriveFundingLogPassedToBookingAge(item === null || item === void 0 ? void 0 : item.PasstoBookingDate),
        bookedDate: formatFundingLogDate(item === null || item === void 0 ? void 0 : item.OriginalBookingDate),
        bookedDateDuration: deriveFundingLogBookingDuration(item === null || item === void 0 ? void 0 : item.PasstoBookingDate, item === null || item === void 0 ? void 0 : item.OriginalBookingDate),
        country: (_b = (_a = FUNDING_LOG_COUNTRY_OPTIONS.find(function (option) { var _a; return option.value === String((_a = item === null || item === void 0 ? void 0 : item.FinanceCompanyAspireId) !== null && _a !== void 0 ? _a : ''); })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '--',
        expectedFundingDate: formatFundingLogDate(item === null || item === void 0 ? void 0 : item.ExpectedFundingDate, FUNDING_LOG_DISPLAY_DATE_ONLY_FORMAT),
        fundingDate: formatFundingLogDate(item === null || item === void 0 ? void 0 : item.FundingDate, FUNDING_LOG_DISPLAY_DATE_ONLY_FORMAT),
        fundingStatus: String(pickFirst(item === null || item === void 0 ? void 0 : item.FundingStatus, '--')),
        program: String(pickFirst(item === null || item === void 0 ? void 0 : item.FinanceProgram, item === null || item === void 0 ? void 0 : item.ProgramAspireOId, '--')),
        amount: Number(pickFirst(item === null || item === void 0 ? void 0 : item.FundingAmount, 0)) || 0,
        fundingMethod: String(pickFirst(item === null || item === void 0 ? void 0 : item.FundingMethod, '--')),
        newCommentsCount: Number(pickFirst(item === null || item === void 0 ? void 0 : item.NewCommentsCount, item === null || item === void 0 ? void 0 : item.CommentsCount, 0)) || 0,
        dealer: String(pickFirst(item === null || item === void 0 ? void 0 : item.DealerName, item === null || item === void 0 ? void 0 : item.Dealer, '--')),
        salesRep: String(pickFirst(item === null || item === void 0 ? void 0 : item.SalesSupportName, '--')),
        submissionType: String(pickFirst(item === null || item === void 0 ? void 0 : item.SubmissionType, '--')),
        raw: item,
    };
};
export var deriveFundingLogCanManage = function (row, accountAspireOId, currentUserRoleTier) {
    var hasAssignment = Boolean(row.assigneeName) || Boolean(row.assigneeTier);
    if (!hasAssignment)
        return true;
    if (isFundingLogRowAssignedToSelf(row, accountAspireOId))
        return true;
    if (row.assigneeTier === 'L2' && !row.assigneeName && currentUserRoleTier === 'L2')
        return true;
    if (row.assigneeTier === 'L1' && currentUserRoleTier === 'L2')
        return true;
    return false;
};
export var useFundingLogRowActions = function () {
    var assignToMe = useCallback(function (txAspireOId, cmAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!txAspireOId)
                        return [2, { success: false }];
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_ASSIGN_CM,
                            payLoad: __assign({ TxAspireOId: txAspireOId }, (cmAspireOId ? { CMAspireOId: cmAspireOId } : {})),
                            showLoader: true,
                            suppressErrorToast: true,
                        })];
                case 2:
                    res = _h.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        utility.alert(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || 'Contract assigned successfully.', constants.TOAST_TYPES.INFO);
                        return [2, { success: true }];
                    }
                    if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.statusCode) === 400) {
                        return [2, { success: false, accountNotInAspire: true }];
                    }
                    utility.alert(((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.message) || 'Unable to assign this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, { success: false }];
                case 3:
                    error_1 = _h.sent();
                    if (((_e = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _e === void 0 ? void 0 : _e.status) === 400) {
                        return [2, { success: false, accountNotInAspire: true }];
                    }
                    utility.alert(((_g = (_f = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message) || (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || 'Unable to assign this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, { success: false }];
                case 4: return [2];
            }
        });
    }); }, []);
    var moveToL2Manager = useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!txAspireOId)
                        return [2, false];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_FUNDING_LOG_L2_ASSIGNMENT,
                            payLoad: { TxAspireOId: txAspireOId },
                            showLoader: true,
                        })];
                case 2:
                    res = _f.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        utility.alert(((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message) || 'Contract moved to L2 Manager successfully.', constants.TOAST_TYPES.INFO);
                        return [2, true];
                    }
                    utility.alert(((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message) || 'Unable to move this contract to L2 Manager.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 3:
                    error_2 = _f.sent();
                    utility.alert(((_e = (_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) || (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || 'Unable to move this contract to L2 Manager.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 4: return [2];
            }
        });
    }); }, []);
    var updateBacklogContractStatus = useCallback(function (row, contractStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var raw, txAspireOId, payload, res, error_3;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    raw = (_a = row.raw) !== null && _a !== void 0 ? _a : {};
                    txAspireOId = pickFirst(raw === null || raw === void 0 ? void 0 : raw.TxAspireOId, row.id);
                    if (!txAspireOId)
                        return [2, false];
                    payload = {
                        TxAspireOId: txAspireOId,
                        ContractStatus: contractStatus,
                    };
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4, api_service.put({
                            endPoint: api_urls.BACKLOG_UNIQUE_STATUS_LIST,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    res = _g.sent();
                    if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.statusCode) === 200) {
                        utility.alert(((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message) || 'Contract updated successfully.', constants.TOAST_TYPES.INFO);
                        return [2, true];
                    }
                    utility.alert(((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.message) || 'Unable to update this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 3:
                    error_3 = _g.sent();
                    utility.alert(((_f = (_e = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) || (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || 'Unable to update this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 4: return [2];
            }
        });
    }); }, []);
    var fetchContractManagers = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, candidateCollections, rawList, seenIds_1, uniqueRawList, error_4;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({ endPoint: api_urls.FUNDING_LOG_CONTRACT_MANAGERS, showLoader: false })];
                case 1:
                    res = _d.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== 200)
                        return [2, []];
                    candidateCollections = [(_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data, res === null || res === void 0 ? void 0 : res.data];
                    rawList = (_c = candidateCollections.find(function (item) { return Array.isArray(item); })) !== null && _c !== void 0 ? _c : [];
                    seenIds_1 = new Set();
                    uniqueRawList = rawList.filter(function (item) {
                        var rawId = pickFirst(item === null || item === void 0 ? void 0 : item.Id);
                        if (rawId === undefined || seenIds_1.has(String(rawId)))
                            return false;
                        seenIds_1.add(String(rawId));
                        return true;
                    });
                    return [2, uniqueRawList
                            .map(function (item) {
                            var _a, _b, _c;
                            var roleDescription = String((_a = item === null || item === void 0 ? void 0 : item.RoleDescription) !== null && _a !== void 0 ? _a : '');
                            var tierLabel = roleDescription.includes('Final Review')
                                ? 'Final Reviewer'
                                : roleDescription.includes('Initial Review')
                                    ? 'Initial Reviewer'
                                    : undefined;
                            var id = pickFirst(item === null || item === void 0 ? void 0 : item.Id);
                            var accountAspireOId = pickFirst(item === null || item === void 0 ? void 0 : item.AccountAspireOId);
                            return {
                                id: id === undefined ? '' : String(id),
                                accountAspireOId: accountAspireOId === undefined ? '' : String(accountAspireOId),
                                name: "".concat((_b = item === null || item === void 0 ? void 0 : item.FirstName) !== null && _b !== void 0 ? _b : '', " ").concat((_c = item === null || item === void 0 ? void 0 : item.LastName) !== null && _c !== void 0 ? _c : '').trim(),
                                tierLabel: tierLabel,
                            };
                        })
                            .filter(function (member) { return member.id && member.name; })];
                case 2:
                    error_4 = _d.sent();
                    return [2, []];
                case 3: return [2];
            }
        });
    }); }, []);
    return { assignToMe: assignToMe, moveToL2Manager: moveToL2Manager, updateBacklogContractStatus: updateBacklogContractStatus, fetchContractManagers: fetchContractManagers };
};
export var useFundingLog = function (queueType, allQueueTypes) {
    if (queueType === void 0) { queueType = 'ALL'; }
    if (allQueueTypes === void 0) { allQueueTypes = ['ALL']; }
    var accountAspireOId = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.AccountAspireOId; });
    var isSalesSupport = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleType; }) === 'SALES_SUPPORT';
    var _a = useState([]), fundingLogRows = _a[0], setFundingLogRows = _a[1];
    var _b = useState(true), isFetching = _b[0], setIsFetching = _b[1];
    var _c = useState(undefined), totalCount = _c[0], setTotalCount = _c[1];
    var _d = useState(null), lastRefreshedAt = _d[0], setLastRefreshedAt = _d[1];
    var _e = useState({}), queueCounts = _e[0], setQueueCounts = _e[1];
    var _f = useState({}), queueAmounts = _f[0], setQueueAmounts = _f[1];
    var _g = useState({}), inProgressCountryAmounts = _g[0], setInProgressCountryAmounts = _g[1];
    var _h = useState(function () { return loadFundingLogNewTracking(accountAspireOId); }), newTracking = _h[0], setNewTracking = _h[1];
    var _j = useState(0), newTick = _j[0], setNewTick = _j[1];
    var lastFetchRowsRef = useRef(null);
    var _k = useState(1), currentPage = _k[0], setCurrentPage = _k[1];
    var _l = useState(100), perPageCount = _l[0], setPerPageCount = _l[1];
    var _m = useState(''), sortBy = _m[0], setSortBy = _m[1];
    var _o = useState('DESC'), sortOrder = _o[0], setSortOrder = _o[1];
    var _p = useState(EMPTY_FUNDING_LOG_FILTERS), appliedFilters = _p[0], setAppliedFilters = _p[1];
    var _q = useState([]), programsList = _q[0], setProgramsList = _q[1];
    var _r = useState([]), statusList = _r[0], setStatusList = _r[1];
    var _s = useState([]), fundingMethodList = _s[0], setFundingMethodList = _s[1];
    var _t = useState([]), financeProgramGroupList = _t[0], setFinanceProgramGroupList = _t[1];
    var _u = useState([]), salesRepList = _u[0], setSalesRepList = _u[1];
    var hasActiveFilters = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return Boolean(appliedFilters.country
            || ((_b = (_a = appliedFilters.programs) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0
            || ((_d = (_c = appliedFilters.status) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0
            || ((_f = (_e = appliedFilters.fundingMethods) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0
            || ((_h = (_g = appliedFilters.financeProgramGroups) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 0
            || ((_k = (_j = appliedFilters.salesRep) === null || _j === void 0 ? void 0 : _j.length) !== null && _k !== void 0 ? _k : 0) > 0
            || appliedFilters.passedToBookingDateStart
            || appliedFilters.expectedFundingDateStart
            || appliedFilters.fundingDateStart
            || appliedFilters.bookedDateStart);
    }, [appliedFilters]);
    var returnedToSalesSupportStatusOId = useMemo(function () {
        var _a;
        return (_a = statusList.find(function (option) { var _a; return ((_a = option.label) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) === SALES_SUPPORT_CONTRACT_STATUS.toLowerCase(); })) === null || _a === void 0 ? void 0 : _a.value;
    }, [statusList]);
    var fundingLogRequestRef = useRef({
        inFlight: false,
        key: '',
        ts: 0,
    });
    var fundingLogFetchSeqRef = useRef(0);
    var fetchProgramsList = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({ endPoint: api_urls.BACKLOG_PROGRAMS_LIST, showLoader: false })];
                case 1:
                    res = _b.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && Array.isArray(res.data.data)) {
                        setProgramsList(res.data.data.map(function (prog) {
                            var _a, _b;
                            return ({
                                label: prog.Description,
                                value: String((_b = (_a = prog.ProgramAspireOId) !== null && _a !== void 0 ? _a : prog.Id) !== null && _b !== void 0 ? _b : ''),
                                ProgramAspireOId: prog.ProgramAspireOId,
                            });
                        }));
                    }
                    return [3, 3];
                case 2:
                    error_5 = _b.sent();
                    setProgramsList([]);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, []);
    var fetchStatusList = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({ endPoint: api_urls.BACKLOG_UNIQUE_STATUS_LIST, showLoader: false })];
                case 1:
                    res = _b.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && Array.isArray(res.data.data)) {
                        setStatusList(res.data.data.map(function (statusObj) { return ({
                            label: statusObj.Status,
                            value: String(statusObj.OId),
                        }); }));
                    }
                    return [3, 3];
                case 2:
                    error_6 = _b.sent();
                    setStatusList([]);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, []);
    var fetchFundingMethodList = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var metadata_1, toOptions, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, fetchAppMetadata()];
                case 1:
                    metadata_1 = _a.sent();
                    if (!metadata_1) {
                        setFundingMethodList([]);
                        setFinanceProgramGroupList([]);
                    }
                    else if (Array.isArray(metadata_1 === null || metadata_1 === void 0 ? void 0 : metadata_1.LTICodes)) {
                        toOptions = function (tableKey) { return metadata_1.LTICodes
                            .filter(function (item) { return item.TableKey === tableKey; })
                            .map(function (item) { return ({
                            label: item.Description,
                            value: String(item.OId),
                        }); }); };
                        setFundingMethodList(toOptions('PAYMENT_TYPE'));
                        setFinanceProgramGroupList(toOptions('FinanceProgramGroup'));
                    }
                    return [3, 3];
                case 2:
                    error_7 = _a.sent();
                    setFundingMethodList([]);
                    setFinanceProgramGroupList([]);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, []);
    var fetchSalesRepList = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, candidateCollections, rawList, error_8;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4, api_service.get({ endPoint: api_urls.BACKLOG_SALES_REP, showLoader: false })];
                case 1:
                    res = _d.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        candidateCollections = [(_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data, res === null || res === void 0 ? void 0 : res.data];
                        rawList = (_c = candidateCollections.find(function (item) { return Array.isArray(item); })) !== null && _c !== void 0 ? _c : [];
                        setSalesRepList(rawList
                            .map(function (item) {
                            var _a, _b;
                            return ({
                                label: String((_a = item === null || item === void 0 ? void 0 : item.Name) !== null && _a !== void 0 ? _a : '').trim(),
                                value: String((_b = item === null || item === void 0 ? void 0 : item.AccountAspireOId) !== null && _b !== void 0 ? _b : ''),
                            });
                        })
                            .filter(function (item) { return item.label && item.value; }));
                    }
                    return [3, 3];
                case 2:
                    error_8 = _d.sent();
                    setSalesRepList([]);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); }, []);
    var buildFundingLogPayload = useCallback(function (targetQueueType, overrides) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var payload = {
            Page: (_a = overrides === null || overrides === void 0 ? void 0 : overrides.page) !== null && _a !== void 0 ? _a : currentPage,
            Size: (_b = overrides === null || overrides === void 0 ? void 0 : overrides.size) !== null && _b !== void 0 ? _b : perPageCount,
        };
        if (sortBy) {
            payload.SortBy = sortBy;
            payload.SortOrder = sortOrder;
        }
        if ((_c = appliedFilters.country) === null || _c === void 0 ? void 0 : _c.value) {
            payload.FinanceCompanyAspireId = appliedFilters.country.value;
        }
        var programAspireOIds = ((_d = appliedFilters.programs) !== null && _d !== void 0 ? _d : []).map(function (program) { return program.value; }).filter(Boolean);
        if (programAspireOIds.length > 0) {
            payload.ProgramAspireOIds = programAspireOIds;
        }
        var contractStatusOIds = ((_e = appliedFilters.status) !== null && _e !== void 0 ? _e : []).map(function (status) { return status.value; }).filter(Boolean);
        if (contractStatusOIds.length > 0) {
            payload.ContractStatusOIds = contractStatusOIds;
        }
        var fundingMethodOIds = ((_f = appliedFilters.fundingMethods) !== null && _f !== void 0 ? _f : []).map(function (method) { return method.value; }).filter(Boolean);
        if (fundingMethodOIds.length > 0) {
            payload.FundingMethodOIds = fundingMethodOIds;
        }
        var financeProgramGroupOIds = ((_g = appliedFilters.financeProgramGroups) !== null && _g !== void 0 ? _g : []).map(function (group) { return group.value; }).filter(Boolean);
        if (financeProgramGroupOIds.length > 0) {
            payload.FinanceProgramGroupOIds = financeProgramGroupOIds;
        }
        var salesSupportOIds = ((_h = appliedFilters.salesRep) !== null && _h !== void 0 ? _h : []).map(function (rep) { return rep.value; }).filter(Boolean);
        if (salesSupportOIds.length > 0) {
            payload.SalesSupportOIds = salesSupportOIds;
        }
        var expectedFundingDateRange = toDateRange(appliedFilters.expectedFundingDateStart, appliedFilters.expectedFundingDateEnd);
        if (expectedFundingDateRange) {
            payload.ExpectedFundingDateRange = expectedFundingDateRange;
        }
        var fundingDateRange = toDateRange(appliedFilters.fundingDateStart, appliedFilters.fundingDateEnd);
        if (fundingDateRange) {
            payload.FundingDateRange = fundingDateRange;
        }
        var passedToBookingDateRange = toDateRange(appliedFilters.passedToBookingDateStart, appliedFilters.passedToBookingDateEnd);
        if (passedToBookingDateRange) {
            payload.PassedtoBookingDateRange = passedToBookingDateRange;
        }
        var bookedDateRange = toDateRange(appliedFilters.bookedDateStart, appliedFilters.bookedDateEnd);
        if (bookedDateRange) {
            payload.OriginalBookingDateRange = bookedDateRange;
        }
        payload.QueueType = targetQueueType;
        if (targetQueueType === 'MY_QUEUE' && accountAspireOId) {
            if (isSalesSupport) {
                payload.SalesSupportAccountOId = accountAspireOId;
            }
            else {
                payload.CMAspireOId = accountAspireOId;
            }
            if (returnedToSalesSupportStatusOId) {
                payload.SSStatusOid = returnedToSalesSupportStatusOId;
            }
        }
        if (targetQueueType === 'RETURNED_TO_SALES_SUPPORT' && returnedToSalesSupportStatusOId) {
            payload.ContractStatusOIds = [returnedToSalesSupportStatusOId];
        }
        return payload;
    }, [currentPage, perPageCount, sortBy, sortOrder, appliedFilters, accountAspireOId, isSalesSupport, returnedToSalesSupportStatusOId]);
    var extractFundingLogCount = function (responseData, rawList) {
        var _a;
        return Number((_a = pickFirst(responseData === null || responseData === void 0 ? void 0 : responseData.Count, responseData === null || responseData === void 0 ? void 0 : responseData.count, responseData === null || responseData === void 0 ? void 0 : responseData.TotalCount, responseData === null || responseData === void 0 ? void 0 : responseData.totalCount, responseData === null || responseData === void 0 ? void 0 : responseData.Total, responseData === null || responseData === void 0 ? void 0 : responseData.total, rawList.length > 0 ? rawList.length : 0)) !== null && _a !== void 0 ? _a : 0);
    };
    var extractFundingLogRawList = function (responseData) { return (Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.Rows) ? responseData.Rows
            : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.rows) ? responseData.rows
                : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.FundingLogs) ? responseData.FundingLogs
                    : Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.fundingLogs) ? responseData.fundingLogs
                        : []); };
    var fetchFundingLogList = useCallback(function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchSeq, isStale, payload, requestKey, now, prevRequest, isDuplicate, res, responseData, rawList, nextTotalCount_1, mappedRows, idsNow, previousFetch_1, flaggedAt_1, added_1, error_9;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    fetchSeq = ++fundingLogFetchSeqRef.current;
                    isStale = function () { return fundingLogFetchSeqRef.current !== fetchSeq; };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    if (queueType === 'MY_QUEUE' && !accountAspireOId) {
                        setIsFetching(false);
                        setFundingLogRows([]);
                        setTotalCount(0);
                        setQueueCounts(function (prev) { return (__assign(__assign({}, prev), { MY_QUEUE: 0 })); });
                        return [2, true];
                    }
                    if (queueType === 'RETURNED_TO_SALES_SUPPORT' && !returnedToSalesSupportStatusOId) {
                        setIsFetching(true);
                        setFundingLogRows([]);
                        return [2, false];
                    }
                    payload = buildFundingLogPayload(queueType);
                    requestKey = JSON.stringify(payload);
                    now = Date.now();
                    prevRequest = fundingLogRequestRef.current;
                    isDuplicate = prevRequest.key === requestKey && (prevRequest.inFlight || now - prevRequest.ts < 800);
                    if (isDuplicate)
                        return [2, false];
                    fundingLogRequestRef.current = { inFlight: true, key: requestKey, ts: now };
                    if (!(options === null || options === void 0 ? void 0 : options.silent)) {
                        setIsFetching(true);
                        setFundingLogRows([]);
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.GET_FUNDING_LOGS,
                            payLoad: payload,
                        })];
                case 2:
                    res = _b.sent();
                    if (isStale())
                        return [2, false];
                    setIsFetching(false);
                    if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                        responseData = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                        rawList = extractFundingLogRawList(responseData);
                        nextTotalCount_1 = extractFundingLogCount(responseData, rawList);
                        mappedRows = rawList.map(function (item) { return mapFundingLogRow(item); });
                        idsNow = new Set(mappedRows.map(function (row) { return row.id; }).filter(Boolean));
                        previousFetch_1 = lastFetchRowsRef.current;
                        if ((options === null || options === void 0 ? void 0 : options.isRefresh) && previousFetch_1 && previousFetch_1.key === requestKey) {
                            flaggedAt_1 = Date.now();
                            added_1 = {};
                            idsNow.forEach(function (id) {
                                if (!previousFetch_1.ids.has(id))
                                    added_1[id] = flaggedAt_1;
                            });
                            if (Object.keys(added_1).length > 0) {
                                setNewTracking(function (prev) {
                                    var _a;
                                    var _b;
                                    return (__assign(__assign({}, prev), { rows: __assign(__assign({}, prev.rows), (_a = {}, _a[queueType] = __assign(__assign({}, added_1), ((_b = prev.rows[queueType]) !== null && _b !== void 0 ? _b : {})), _a)) }));
                                });
                            }
                        }
                        lastFetchRowsRef.current = { key: requestKey, ids: idsNow };
                        setFundingLogRows(mappedRows);
                        if (hasActiveFilters) {
                            setTotalCount(nextTotalCount_1);
                        }
                        else {
                            setQueueCounts(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a[queueType] = nextTotalCount_1, _a)));
                            });
                        }
                        return [2, true];
                    }
                    else if (!hasActiveFilters) {
                        setQueueCounts(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[queueType] = 0, _a)));
                        });
                        return [2, true];
                    }
                    return [2, false];
                case 3:
                    error_9 = _b.sent();
                    if (!isStale())
                        setIsFetching(false);
                    return [2, false];
                case 4:
                    fundingLogRequestRef.current.inFlight = false;
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [buildFundingLogPayload, queueType, perPageCount, sortBy, sortOrder, appliedFilters, hasActiveFilters, accountAspireOId, returnedToSalesSupportStatusOId]);
    var QUEUE_COUNT_RESPONSE_KEYS = {
        IN_PROGRESS: 'FundingInProgress',
        MY_QUEUE: 'MyQueue',
        UNASSIGNED: 'Unassigned',
        RETURNED_TO_SALES_SUPPORT: 'ReturnedToSalesSupport',
        ALL: 'All',
        L2_REVIEW_QUEUE: 'SecondReviewQueue',
    };
    var fetchAllQueueCounts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, Page, Size, SortBy, SortOrder, QueueType, filterPayload, res, counts_1, nextCounts_1, nextAmounts_1, error_10;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!returnedToSalesSupportStatusOId) {
                        return [2, null];
                    }
                    _a = buildFundingLogPayload('ALL'), Page = _a.Page, Size = _a.Size, SortBy = _a.SortBy, SortOrder = _a.SortOrder, QueueType = _a.QueueType, filterPayload = __rest(_a, ["Page", "Size", "SortBy", "SortOrder", "QueueType"]);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.post({
                            endPoint: api_urls.GET_FUNDING_LOGS_COUNT,
                            payLoad: __assign(__assign(__assign({}, filterPayload), (accountAspireOId ? (isSalesSupport ? { SalesSupportAccountOId: accountAspireOId } : { CMAspireOId: accountAspireOId }) : {})), { SSStatusOid: returnedToSalesSupportStatusOId }),
                            showLoader: false,
                        })];
                case 2:
                    res = _d.sent();
                    if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                        counts_1 = (_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : {};
                        nextCounts_1 = {};
                        nextAmounts_1 = {};
                        Object.keys(QUEUE_COUNT_RESPONSE_KEYS).forEach(function (targetQueueType) {
                            var responseKey = QUEUE_COUNT_RESPONSE_KEYS[targetQueueType];
                            var rawCount = counts_1 === null || counts_1 === void 0 ? void 0 : counts_1[responseKey];
                            if (rawCount !== undefined) {
                                nextCounts_1[targetQueueType] = Number(rawCount) || 0;
                            }
                            var rawAmount = counts_1 === null || counts_1 === void 0 ? void 0 : counts_1["".concat(responseKey, "Amount")];
                            if (rawAmount !== undefined) {
                                nextAmounts_1[targetQueueType] = Number(rawAmount) || 0;
                            }
                        });
                        if (!accountAspireOId) {
                            nextCounts_1.MY_QUEUE = 0;
                            nextAmounts_1.MY_QUEUE = 0;
                        }
                        setQueueAmounts(nextAmounts_1);
                        setInProgressCountryAmounts({
                            us: (counts_1 === null || counts_1 === void 0 ? void 0 : counts_1.UsInProgressAmount) !== undefined ? Number(counts_1.UsInProgressAmount) || 0 : undefined,
                            canada: (counts_1 === null || counts_1 === void 0 ? void 0 : counts_1.CanadaInProgressAmount) !== undefined ? Number(counts_1.CanadaInProgressAmount) || 0 : undefined,
                        });
                        setQueueCounts(function (prev) { return (__assign(__assign({}, prev), nextCounts_1)); });
                        return [2, nextCounts_1];
                    }
                    return [2, null];
                case 3:
                    error_10 = _d.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    }); }, [accountAspireOId, isSalesSupport, returnedToSalesSupportStatusOId, buildFundingLogPayload]);
    var queueCountsRef = useRef({});
    useEffect(function () {
        queueCountsRef.current = queueCounts;
    }, [queueCounts]);
    var hasFetchedCountsRef = useRef(false);
    var countsPrerequisitesReady = Boolean(returnedToSalesSupportStatusOId);
    var syncQueueTypeData = useCallback(function (forceCountsRefetch, silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var counts, countsBefore_1, hadCountsBefore, fetched_1, increasedAt_1, increases_1, knownCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!silent) {
                            setIsFetching(true);
                            setFundingLogRows([]);
                        }
                        counts = queueCountsRef.current;
                        if (!(forceCountsRefetch || !hasFetchedCountsRef.current)) return [3, 3];
                        if (!countsPrerequisitesReady) return [3, 2];
                        countsBefore_1 = queueCountsRef.current;
                        hadCountsBefore = hasFetchedCountsRef.current;
                        return [4, fetchAllQueueCounts()];
                    case 1:
                        fetched_1 = _a.sent();
                        if (fetched_1) {
                            hasFetchedCountsRef.current = true;
                            counts = fetched_1;
                            if (forceCountsRefetch && hadCountsBefore) {
                                increasedAt_1 = Date.now();
                                increases_1 = Object.keys(fetched_1)
                                    .filter(function (queue) { var _a, _b; return countsBefore_1[queue] !== undefined && ((_a = fetched_1[queue]) !== null && _a !== void 0 ? _a : 0) > ((_b = countsBefore_1[queue]) !== null && _b !== void 0 ? _b : 0); })
                                    .map(function (queue) { var _a, _b; return ({ queue: queue, delta: ((_a = fetched_1[queue]) !== null && _a !== void 0 ? _a : 0) - ((_b = countsBefore_1[queue]) !== null && _b !== void 0 ? _b : 0) }); });
                                if (increases_1.length > 0) {
                                    setNewTracking(function (prev) {
                                        var bumps = __assign({}, prev.bumps);
                                        increases_1.forEach(function (_a) {
                                            var _b;
                                            var queue = _a.queue, delta = _a.delta;
                                            bumps[queue] = __spreadArray(__spreadArray([], ((_b = bumps[queue]) !== null && _b !== void 0 ? _b : []), true), [{ delta: delta, at: increasedAt_1 }], false);
                                        });
                                        return __assign(__assign({}, prev), { bumps: bumps });
                                    });
                                }
                            }
                        }
                        return [3, 3];
                    case 2:
                        if (!hasFetchedCountsRef.current) {
                            return [2];
                        }
                        _a.label = 3;
                    case 3:
                        if (!hasActiveFilters) return [3, 5];
                        return [4, fetchFundingLogList({ isRefresh: forceCountsRefetch, silent: silent })];
                    case 4:
                        if (_a.sent()) {
                            setLastRefreshedAt(new Date());
                        }
                        return [2];
                    case 5:
                        knownCount = counts[queueType];
                        if (knownCount === 0) {
                            setFundingLogRows([]);
                            setIsFetching(false);
                            lastFetchRowsRef.current = null;
                            setLastRefreshedAt(new Date());
                            return [2];
                        }
                        return [4, fetchFundingLogList({ isRefresh: forceCountsRefetch, silent: silent })];
                    case 6:
                        if (_a.sent()) {
                            setLastRefreshedAt(new Date());
                        }
                        return [2];
                }
            });
        });
    }, [queueType, hasActiveFilters, countsPrerequisitesReady, fetchAllQueueCounts, fetchFundingLogList]);
    useEffect(function () {
        hasFetchedCountsRef.current = false;
    }, [queueType]);
    useEffect(function () {
        syncQueueTypeData(false);
    }, [syncQueueTypeData]);
    useEffect(function () {
        if (!hasActiveFilters) {
            setTotalCount(queueCounts[queueType]);
        }
    }, [queueCounts, queueType, hasActiveFilters]);
    var _v = useState(false), isManualRefreshing = _v[0], setIsManualRefreshing = _v[1];
    var _w = useState(false), isRefreshingInBackground = _w[0], setIsRefreshingInBackground = _w[1];
    var refreshCurrentQueue = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsManualRefreshing(true);
                    setIsRefreshingInBackground(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4, syncQueueTypeData(true, true)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    setIsManualRefreshing(false);
                    setIsRefreshingInBackground(false);
                    return [7];
                case 4: return [2];
            }
        });
    }); }, [syncQueueTypeData]);
    var silentRefreshCurrentQueue = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRefreshingInBackground(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4, syncQueueTypeData(true, true)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    setIsRefreshingInBackground(false);
                    return [7];
                case 4: return [2];
            }
        });
    }); }, [syncQueueTypeData]);
    var refreshCurrentQueueRef = useRef(silentRefreshCurrentQueue);
    useEffect(function () {
        refreshCurrentQueueRef.current = silentRefreshCurrentQueue;
    }, [silentRefreshCurrentQueue]);
    var FUNDING_LOG_AUTO_REFRESH_INTERVAL_MS = 2 * 60 * 1000;
    useEffect(function () {
        if (!lastRefreshedAt) {
            return;
        }
        var elapsedMs = Date.now() - lastRefreshedAt.getTime();
        var remainingMs = Math.max(FUNDING_LOG_AUTO_REFRESH_INTERVAL_MS - elapsedMs, 0);
        var timeoutId = window.setTimeout(function () {
            refreshCurrentQueueRef.current();
        }, remainingMs);
        return function () { return window.clearTimeout(timeoutId); };
    }, [lastRefreshedAt]);
    useEffect(function () {
        setNewTracking(loadFundingLogNewTracking(accountAspireOId));
    }, [accountAspireOId]);
    useEffect(function () {
        saveFundingLogNewTracking(accountAspireOId, newTracking);
    }, [accountAspireOId, newTracking]);
    useEffect(function () {
        var nextExpiry = getNextExpiry(newTracking);
        if (nextExpiry === undefined)
            return;
        var timeoutId = window.setTimeout(function () {
            setNewTracking(function (prev) { return pruneFundingLogNewTracking(prev); });
            setNewTick(function (tick) { return tick + 1; });
        }, Math.max(nextExpiry - Date.now(), 0) + 50);
        return function () { return window.clearTimeout(timeoutId); };
    }, [newTracking]);
    var newRowIds = useMemo(function () { return getNewRowIds(newTracking, queueType); }, [newTracking, queueType, newTick]);
    var newCounts = useMemo(function () { return getNewCounts(newTracking); }, [newTracking, newTick]);
    var displayRows = useMemo(function () {
        if (newRowIds.size === 0)
            return fundingLogRows;
        var passedToBookingAt = function (row) {
            var _a;
            var parsed = moment((_a = row.raw) === null || _a === void 0 ? void 0 : _a.PasstoBookingDate);
            return parsed.isValid() ? parsed.valueOf() : 0;
        };
        var fresh = fundingLogRows.filter(function (row) { return newRowIds.has(row.id); }).sort(function (a, b) { return passedToBookingAt(b) - passedToBookingAt(a); });
        return __spreadArray(__spreadArray([], fresh, true), fundingLogRows.filter(function (row) { return !newRowIds.has(row.id); }), true);
    }, [fundingLogRows, newRowIds]);
    useEffect(function () {
        fetchProgramsList();
        fetchStatusList();
        fetchSalesRepList();
    }, []);
    var handleTableSortChange = useCallback(function (nextSortBy, nextSortOrder) {
        setSortBy(nextSortBy);
        setSortOrder(nextSortOrder);
        setCurrentPage(1);
    }, []);
    var fetchComments = useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_11;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!txAspireOId)
                        return [2, []];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_COMMENTS,
                            payLoad: { TxAspireOId: txAspireOId, CommentTypes: ['FUNDLOG'] },
                            showLoader: false,
                        })];
                case 2:
                    res = _c.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && Array.isArray((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data)) {
                        return [2, res.data.data];
                    }
                    return [2, []];
                case 3:
                    error_11 = _c.sent();
                    utility.alert('Unable to load comments.', constants.TOAST_TYPES.ERROR);
                    return [2, []];
                case 4: return [2];
            }
        });
    }); }, []);
    var sendComment = useCallback(function (txAspireOId, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var res, raw, error_12;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    if (!txAspireOId)
                        return [2, null];
                    _r.label = 1;
                case 1:
                    _r.trys.push([1, 3, , 4]);
                    return [4, api_service.post({
                            endPoint: api_urls.BACKLOG_COMMENT,
                            payLoad: {
                                TxAspireOId: txAspireOId,
                                Subject: payload.subject,
                                Text: payload.message,
                                CommentType: payload.CommentType,
                            },
                        })];
                case 2:
                    res = _r.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        raw = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                        utility.alert(((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message) || 'Comment added successfully', constants.TOAST_TYPES.INFO);
                        return [2, {
                                Text: (_f = (_e = (_d = raw === null || raw === void 0 ? void 0 : raw.Text) !== null && _d !== void 0 ? _d : raw === null || raw === void 0 ? void 0 : raw.CommentText) !== null && _e !== void 0 ? _e : raw === null || raw === void 0 ? void 0 : raw.Description) !== null && _f !== void 0 ? _f : payload.message,
                                Subject: (_h = (_g = raw === null || raw === void 0 ? void 0 : raw.Subject) !== null && _g !== void 0 ? _g : raw === null || raw === void 0 ? void 0 : raw.CommentSubject) !== null && _h !== void 0 ? _h : payload.subject,
                                CommentedBy: (_k = (_j = raw === null || raw === void 0 ? void 0 : raw.CommentedBy) !== null && _j !== void 0 ? _j : raw === null || raw === void 0 ? void 0 : raw.CreatedBy) !== null && _k !== void 0 ? _k : 'You',
                                CommentType: (_l = raw === null || raw === void 0 ? void 0 : raw.CommentType) !== null && _l !== void 0 ? _l : payload.CommentType.Code,
                                CommentTypeDescription: (_m = raw === null || raw === void 0 ? void 0 : raw.CommentTypeDescription) !== null && _m !== void 0 ? _m : payload.CommentType.Description,
                                CreatedTime: (_p = (_o = raw === null || raw === void 0 ? void 0 : raw.CreatedTime) !== null && _o !== void 0 ? _o : raw === null || raw === void 0 ? void 0 : raw.CreatedDate) !== null && _p !== void 0 ? _p : new Date().toISOString(),
                            }];
                    }
                    utility.alert(((_q = res === null || res === void 0 ? void 0 : res.data) === null || _q === void 0 ? void 0 : _q.message) || 'Unable to add comment.', constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 3:
                    error_12 = _r.sent();
                    utility.alert('Unable to add comment.', constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 4: return [2];
            }
        });
    }); }, []);
    var rowActions = useFundingLogRowActions();
    var assignToMe = useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, rowActions.assignToMe(txAspireOId)];
                case 1:
                    result = _a.sent();
                    if (!result.success) return [3, 4];
                    setQueueCounts(function (prev) { var _a; return (__assign(__assign({}, prev), { MY_QUEUE: ((_a = prev.MY_QUEUE) !== null && _a !== void 0 ? _a : 0) + 1 })); });
                    return [4, fetchFundingLogList()];
                case 2:
                    _a.sent();
                    return [4, fetchAllQueueCounts()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2, result];
            }
        });
    }); }, [rowActions.assignToMe, fetchFundingLogList, fetchAllQueueCounts]);
    var reassignToOther = useCallback(function (txAspireOId, cmAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, rowActions.assignToMe(txAspireOId, cmAspireOId)];
                case 1:
                    result = _a.sent();
                    if (!result.success) return [3, 3];
                    return [4, fetchFundingLogList()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2, result];
            }
        });
    }); }, [rowActions.assignToMe, fetchFundingLogList]);
    var moveToL2Manager = useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, rowActions.moveToL2Manager(txAspireOId)];
                case 1:
                    success = _a.sent();
                    if (!success) return [3, 4];
                    return [4, fetchFundingLogList()];
                case 2:
                    _a.sent();
                    return [4, fetchAllQueueCounts()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2, success];
            }
        });
    }); }, [rowActions.moveToL2Manager, fetchFundingLogList, fetchAllQueueCounts]);
    var updateBacklogContractStatus = useCallback(function (row, contractStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, rowActions.updateBacklogContractStatus(row, contractStatus)];
                case 1:
                    success = _a.sent();
                    if (!success) return [3, 4];
                    return [4, fetchFundingLogList()];
                case 2:
                    _a.sent();
                    return [4, fetchAllQueueCounts()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2, success];
            }
        });
    }); }, [rowActions.updateBacklogContractStatus, fetchFundingLogList, fetchAllQueueCounts]);
    var fetchContractStatusHistory = useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, history_1, error_13;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!txAspireOId)
                        return [2, []];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_MAIN_INFO,
                            payLoad: { TxAspireOId: txAspireOId },
                            showLoader: false,
                        })];
                case 2:
                    res = _e.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        history_1 = (_d = (_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.History) === null || _d === void 0 ? void 0 : _d.ContractStatusHistory;
                        return [2, Array.isArray(history_1) ? history_1 : []];
                    }
                    return [2, []];
                case 3:
                    error_13 = _e.sent();
                    utility.alert('Unable to load contract status history.', constants.TOAST_TYPES.ERROR);
                    return [2, []];
                case 4: return [2];
            }
        });
    }); }, []);
    var applyFilters = useCallback(function (draft) {
        hasFetchedCountsRef.current = false;
        setAppliedFilters(draft);
        setCurrentPage(1);
    }, []);
    var resetFilters = useCallback(function () {
        hasFetchedCountsRef.current = false;
        setAppliedFilters(EMPTY_FUNDING_LOG_FILTERS);
        setCurrentPage(1);
    }, []);
    var fetchFundingLogRowsForExport = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, rawList, error_14;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (totalCount !== undefined && displayRows.length >= totalCount)
                        return [2, { rows: displayRows, total: totalCount }];
                    if (queueType === 'MY_QUEUE' && !accountAspireOId)
                        return [2, { rows: [], total: 0 }];
                    if (queueType === 'RETURNED_TO_SALES_SUPPORT' && !returnedToSalesSupportStatusOId)
                        return [2, { rows: [], total: 0 }];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.post({
                            endPoint: api_urls.GET_FUNDING_LOGS,
                            payLoad: buildFundingLogPayload(queueType, { page: 1, size: Math.max(totalCount !== null && totalCount !== void 0 ? totalCount : 0, perPageCount) }),
                            showLoader: false,
                        })];
                case 2:
                    res = _d.sent();
                    if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== 200)
                        return [2, null];
                    rawList = extractFundingLogRawList((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data);
                    return [2, {
                            rows: rawList.map(function (item) { return mapFundingLogRow(item); }),
                            total: extractFundingLogCount((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data, rawList),
                        }];
                case 3:
                    error_14 = _d.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    }); }, [displayRows, totalCount, queueType, accountAspireOId, returnedToSalesSupportStatusOId, perPageCount, buildFundingLogPayload]);
    return {
        fundingLogRows: displayRows,
        newRowIds: newRowIds,
        newCounts: newCounts,
        isManualRefreshing: isManualRefreshing,
        isRefreshingInBackground: isRefreshingInBackground,
        isFetching: isFetching,
        totalCount: totalCount,
        queueCounts: queueCounts,
        queueAmounts: queueAmounts,
        inProgressCountryAmounts: inProgressCountryAmounts,
        refreshCurrentQueue: refreshCurrentQueue,
        fetchFundingLogRowsForExport: fetchFundingLogRowsForExport,
        lastRefreshedAt: lastRefreshedAt,
        accountAspireOId: accountAspireOId,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        perPageCount: perPageCount,
        setPerPageCount: setPerPageCount,
        sortBy: sortBy,
        sortOrder: sortOrder,
        handleTableSortChange: handleTableSortChange,
        appliedFilters: appliedFilters,
        applyFilters: applyFilters,
        resetFilters: resetFilters,
        programsList: programsList,
        statusList: statusList,
        fundingMethodList: fundingMethodList,
        financeProgramGroupList: financeProgramGroupList,
        fetchFundingMethodList: fetchFundingMethodList,
        salesRepList: salesRepList,
        fetchComments: fetchComments,
        sendComment: sendComment,
        assignToMe: assignToMe,
        moveToL2Manager: moveToL2Manager,
        updateBacklogContractStatus: updateBacklogContractStatus,
        reassignToOther: reassignToOther,
        fetchContractManagers: rowActions.fetchContractManagers,
        fetchContractStatusHistory: fetchContractStatusHistory,
    };
};
export default useFundingLog;
